import * as React from 'react';
import Orders from './Orders.js';

const OrdersContainer = ({ showOrderDate  })=>{
    return /*#__PURE__*/ React.createElement(Orders, {
        showOrderDate: showOrderDate
    });
};

export { OrdersContainer as default };
//# sourceMappingURL=OrdersContainer.js.map
